import { connect } from 'react-redux';
import View from './LargePurchaseView';
import MobileView from '../../MobileFinancialPlan/MobileLargePurchase/MobileLargePurchaseView';
import { setReactCalibrationWidget } from '../FinancialPlanActions';
import { calibration, data as dataSelector } from '../FinancialPlanSelector';
import {
  goalId as goalIdSelector,
  goalViewState as goalViewStateSelector,
} from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { getGoal } from '../FinancialPlanHelpers';
import { isCurrentPlanSelector } from '../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsSelector';
import { OVERVIEW } from '../Explanations/ExplanationsConst';
import { assumptionsLabelSelector, assumptionValuesSelector } from './LargePurchaseSelector';

const mapStateToProps = (state, ownProps) => {
  const data = dataSelector(state, ownProps);
  const goalId = goalIdSelector(state, ownProps);
  const goal = getGoal(data, goalId);

  const selectedSection = goalViewStateSelector(state, ownProps).selectedSection || OVERVIEW;

  let largePurchaseGoal;

  if (goal.GoalType === 'largePurchase') {
    largePurchaseGoal = goal;
  }

  if (ownProps.isPrint) {
    largePurchaseGoal = ownProps.goal;
  }

  return {
    calibration: calibration(state, ownProps),
    goalId: goal.GoalId,
    largePurchaseGoal,
    data,
    isCurrentPlan: isCurrentPlanSelector(state, ownProps),
    largePurchaseAssumptionValues: assumptionValuesSelector(state, ownProps),
    largePurchaseAssumptionLabels: assumptionsLabelSelector(state, ownProps),
    selectedSection,
  };
};

const mapDispatchToProps = dispatch => ({
  setReactCalibrationWidget: (calibration, clientId) => {
    dispatch(setReactCalibrationWidget(calibration, clientId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);

export const MobileLargePurchase = connect(mapStateToProps, mapDispatchToProps)(MobileView);
